import React from 'react';

interface FormSectionProps {
  title: string;
  description?: string;
  children: React.ReactNode;
}

export const FormSection: React.FC<FormSectionProps> = ({ title, description, children }) => {
  return (
    <div style={{
      background: 'white',
      border: '0.5px solid var(--color-border)',
      borderRadius: 'var(--radius-lg)',
      padding: '14px 16px',
    }}>
      <h3 style={{ fontSize: 13, fontWeight: 500, color: 'var(--color-text-primary)', marginBottom: description ? 6 : 12 }}>
        {title}
      </h3>

      {description && (
        <p style={{ fontSize: 12, color: 'var(--color-text-secondary)', marginBottom: 12 }}>
          {description}
        </p>
      )}

      <div className="space-y-4">
        {children}
      </div>
    </div>
  );
};

export default FormSection;
